import { Link } from "react-router-dom";
import Top from "./Top";
import Footer from "./Footer";
import { useEffect, useState } from "react";
import html2pdf from "html2pdf.js";

function Payments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  const userDetails = JSON.parse(
    localStorage.getItem("SLNUserDetails") || "{}",
  );
  const userId = userDetails?.userId;
  const token = localStorage.getItem("SLNToken");

  const reqHeaders = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: token } : {}),
  };

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `https://522gqh3w18.execute-api.ap-south-1.amazonaws.com/Prod/Payment/GetPaymentHistory?userId=${userId}`,
          { headers: reqHeaders },
        );
        const data = await res.json();
        setPayments(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        console.error("Failed to fetch payments:", err);
      } finally {
        setLoading(false);
      }
    };
    if (userId) fetchPayments();
    else setLoading(false);
  }, []);

  const formatDate = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateShort = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const fmt = (n, dec = 2) =>
    Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: dec });

  // ── Generate & download invoice PDF (same pattern as reference) ───────────
  const generateInvoice = (payment) => {
    const course = payment.course || {};
    const instructor = course.instructors?.[0] || {};
    const pricing = payment.pricing || {};

    const invoiceNumber = `INV-${(payment._id || "").toString().slice(-8).toUpperCase()}`;
    const issueDate = formatDateShort(payment.createdAt);
    const baseAmount = Number(pricing.baseAmount || 0);
    const gstAmount = Number(pricing.gstAmount || 0);
    const gstPct = Number(pricing.gstPercentage || 0);
    const totalAmount = Number(pricing.totalAmount || 0);
    const originalPrice = Number(course.originalPrice || baseAmount);
    const discountAmt = originalPrice - baseAmount;
    const discountPct =
      originalPrice > 0
        ? ((discountAmt / originalPrice) * 100).toFixed(2)
        : "0.00";

    const element = document.createElement("div");
    element.innerHTML = `
      <div style="font-family: Arial, sans-serif; padding: 32px; color: #1a1a1a; max-width: 760px;">
 
        <!-- HEADER -->
        <div style="display:flex; justify-content:space-between; align-items:flex-start;">
          <div>
            <img
              src="/assets/images/logo.png"
              width="50"
            />
            <p style="margin:5px 0 2px; font-size:15px; font-weight:700; color:#111;">SLN Academy</p>
            <p style="margin:0; font-size:11px; color:#999;">Best Stock Market Institute in India</p>
          </div>
          <div style="text-align:right;">
            <h1 style="margin:0; font-size:30px; letter-spacing:-1px; color:#111;">Invoice</h1>
            <p style="margin:6px 0 0; font-size:12px; color:#666; line-height:1.2;">
              <strong style="color:#111;">Invoice No:</strong> ${invoiceNumber}<br/>
              <strong style="color:#111;">Date Issued:</strong> ${issueDate}<br/>
              <strong style="color:#111;">Course Ref:</strong> ${payment.courseId || "—"}<br/>
              <strong style="color:#111;">Order ID:</strong> ${payment.orderId || "—"}
            </p>
          </div>
        </div>
 
        <!-- DIVIDER -->
        <hr style="margin:22px 0; border:none; border-top:1px solid #eee;" />
 
        <!-- BILLED TO / FROM / DELIVER -->
        <div style="display:flex; justify-content:space-between; gap:16px; background:#fafafa; border:1px solid #f0f0f0; border-radius:10px; padding:18px 20px; margin-bottom:22px;">
 
          <div style="flex:1;">
            <p style="margin:0 0 6px; font-size:9.5px; text-transform:uppercase; letter-spacing:1px; color:#e53935; font-weight:700;">From</p>
            <p style="margin:4px 0 0; font-size:11.5px; color:#666; line-height:1.3;">
              SLN Academy<br/>
              NISM Certified Trainer<br/>
              Stock Market Education, India
            </p>
          </div>
 
          <div style="flex:1;">
            <p style="margin:0 0 6px; font-size:9.5px; text-transform:uppercase; letter-spacing:1px; color:#e53935; font-weight:700;">Billed To</p>
            <p style="margin:0; font-size:13px; font-weight:700; color:#111;">${userDetails?.name || "Student"}</p>
            <p style="margin:4px 0 0; font-size:11.5px; color:#666; line-height:1.3;">
              User ID: ${userDetails?.userId || "—"}<br/>
              Email: ${userDetails?.email || "—"}<br/>
              Phone: +91 ${userDetails?.phone || "—"}<br/>
              Member Since: ${formatDateShort(userDetails?.createdAt)}
            </p>
          </div>
 
          <div style="flex:1;">
            <p style="margin:0 0 6px; font-size:9.5px; text-transform:uppercase; letter-spacing:1px; color:#e53935; font-weight:700;">Deliver To</p>
            <p style="margin:0; font-size:13px; font-weight:700; color:#111;">Digital Delivery</p>
            <p style="margin:4px 0 0; font-size:11.5px; color:#666; line-height:1.3;">
              Online Course Access<br/>
              Lifetime Recorded Sessions<br/>
              24×7 WhatsApp Support
            </p>
          </div>
 
        </div>
 
        <p style="font-size:12px; color:#666; margin-bottom:16px;">
          Type of Service: <strong style="color:#111;">Online Education / Professional Certificate</strong>
        </p>
 
        <!-- ORDER TABLE -->
        <table style="width:100%; border-collapse:collapse; margin-bottom:20px;">
          <thead>
            <tr style="background:#f5f5f5;">
              <th style="text-align:left;   padding:10px 12px; font-size:10.5px; text-transform:uppercase; letter-spacing:.5px; color:#777; font-weight:700; border-bottom:1px solid #eee;">Item</th>
              <th style="text-align:center; padding:10px 12px; font-size:10.5px; text-transform:uppercase; letter-spacing:.5px; color:#777; font-weight:700; border-bottom:1px solid #eee;">Qty</th>
              <th style="text-align:center; padding:10px 12px; font-size:10.5px; text-transform:uppercase; letter-spacing:.5px; color:#777; font-weight:700; border-bottom:1px solid #eee;">Price</th>
              <th style="text-align:center; padding:10px 12px; font-size:10.5px; text-transform:uppercase; letter-spacing:.5px; color:#777; font-weight:700; border-bottom:1px solid #eee;">Discount</th>
              <th style="text-align:center; padding:10px 12px; font-size:10.5px; text-transform:uppercase; letter-spacing:.5px; color:#777; font-weight:700; border-bottom:1px solid #eee;">Tax</th>
              <th style="text-align:right;  padding:10px 12px; font-size:10.5px; text-transform:uppercase; letter-spacing:.5px; color:#777; font-weight:700; border-bottom:1px solid #eee;">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="padding:12px; font-size:12.5px; border-bottom:1px solid #f0f0f0; vertical-align:top;">
                <strong style="color:#111;">${course.title || payment.courseId}</strong><br/>
                <span style="font-size:10.5px; color:#aaa; line-height:1.3;">
                  ${course.category || "Online Course"} &middot; Live + Recorded<br/>
                  Delivery: ${issueDate}
                </span>
              </td>
              <td style="padding:12px; font-size:12.5px; text-align:center; border-bottom:1px solid #f0f0f0;">1</td>
              <td style="padding:12px; font-size:12.5px; text-align:center; border-bottom:1px solid #f0f0f0;">&#8377;${fmt(originalPrice, 0)}</td>
              <td style="padding:12px; font-size:12.5px; text-align:center; border-bottom:1px solid #f0f0f0;">${discountPct}%</td>
              <td style="padding:12px; font-size:12.5px; text-align:center; border-bottom:1px solid #f0f0f0;">&#8377;${fmt(baseAmount)}</td>
              <td style="padding:12px; font-size:12.5px; text-align:right;  border-bottom:1px solid #f0f0f0;">&#8377;${fmt(baseAmount)}</td>
            </tr>
          </tbody>
        </table>
 
        <!-- TOTALS -->
        <div style="display:flex; justify-content:flex-end; margin-bottom:24px;">
          <div style="width:260px;">
            ${
              originalPrice > baseAmount
                ? `
            <div style="display:flex; justify-content:space-between; font-size:12.5px; padding:5px 0; color:#ccc; text-decoration:line-through;">
              <span>MRP</span><span>&#8377;${fmt(originalPrice, 0)}</span>
            </div>`
                : ""
            }
            <div style="display:flex; justify-content:space-between; font-size:12.5px; padding:5px 0; color:#555;">
              <span>Total (excl. GST)</span><span>&#8377;${fmt(baseAmount)}</span>
            </div>
            <div style="display:flex; justify-content:space-between; font-size:12.5px; padding:5px 0; color:#555;">
              <span>Discount</span><span>-&#8377;${fmt(discountAmt)}</span>
            </div>
            <div style="display:flex; justify-content:space-between; font-size:12.5px; padding:5px 0; color:#555;">
              <span>GST (${gstPct}%)</span><span>&#8377;${fmt(gstAmount)}</span>
            </div>
            <hr style="border:none; border-top:2px solid #e53935; margin:8px 0;" />
            <div style="display:flex; justify-content:space-between; font-size:15px; font-weight:700; color:#e53935; padding-top:4px;">
              <span>Total Due</span><span>&#8377;${fmt(totalAmount)}</span>
            </div>
          </div>
        </div> 
      </div>
    `;

    html2pdf()
      .set({
        margin: 10,
        filename: `Invoice_${invoiceNumber}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          scale: 4,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      })
      .from(element)
      .save();
  };

  return (
    <>
      <Top />

      <section>
        <div className="container mb-8">
          <div className="row pt-4">
            <div className="col-12">
              <span className="badge bg-dark-soft rounded-pill fs-5 px-4">
                My <span className="fw-bold">Payments</span>
              </span>
              <p className="m-0 fs-4 lh-sm mt-1">
                Your Payment History / Courses Payment
              </p>
            </div>

            <div className="row g-3 mt-2">
              {loading ? (
                <div className="text-center">
                  <div
                    className="spinner-border text-success mb-3"
                    style={{ width: 48, height: 48 }}
                    role="status"
                  />
                </div>
              ) : payments.length === 0 ? (
                <div className="col-12 text-center py-5">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/600/600277.png"
                    width="120"
                    alt=""
                  />
                  <p className="text-muted mt-3">No payment history found.</p>
                </div>
              ) : (
                payments.map((payment, index) => {
                  const course = payment.course || {};
                  const instructor = course.instructors?.[0] || {};
                  const pricing = payment.pricing || {};
                  const baseAmount = Number(pricing.baseAmount || 0);
                  const gstAmount = Number(pricing.gstAmount || 0);
                  const gstPct = Number(pricing.gstPercentage || 0);
                  const totalAmount = Number(pricing.totalAmount || 0);
                  const originalPrice = Number(
                    course.originalPrice || baseAmount,
                  );

                  return (
                    <div
                      className="col-lg-4 col-md-6 col-12"
                      key={payment._id || index}
                    >
                      <div className="card border rounded-5 shadow-none h-100">
                        <div className="card-body d-flex flex-column px-4 py-4">
                          {/* Title */}
                          <h5 className="mb-0 lh-1">
                            <Link
                              to={`/explore-course/${payment.courseId}`}
                              className="text-dark fs-4"
                            >
                              {course.title || payment.courseId}
                            </Link>
                          </h5>

                          <p className="mb-2 mt-1 lh-sm">
                            {course.description?.slice(0, 80)}...
                          </p>

                          {/* Category */}
                          {course.category && (
                            <span
                              className="badge bg-success-subtle text-success rounded-pill mt-2"
                              style={{ width: "fit-content" }}
                            >
                              {course.category}
                            </span>
                          )}

                          {/* Instructor */}
                          {instructor.name && (
                            <div className="d-flex align-items-center gap-2 mt-3">
                              {instructor.profileImage && (
                                <img
                                  src={instructor.profileImage}
                                  alt={instructor.name}
                                  className="rounded-circle object-fit-cover object-position-top"
                                  style={{ width: 30, height: 30 }}
                                />
                              )}
                              <small className="text-muted fw-medium">
                                {instructor.name}
                              </small>
                              {instructor.rating && (
                                <small className="ms-auto text-warning fw-semibold">
                                  ⭐ {instructor.rating}
                                </small>
                              )}
                            </div>
                          )}

                          <hr className="my-3" />

                          {/* Price block */}
                          <div
                            className="d-flex justify-content-between align-items-center rounded-3 px-3 py-2 mb-2"
                            style={{
                              background: "#f0fdf4",
                              border: "1px solid #d1fae5",
                            }}
                          >
                            <div>
                              <div className="text-muted lh-1 text-dark">
                                Amount Paid (incl. GST)
                              </div>
                              {originalPrice > baseAmount && (
                                <div className="text-muted text-decoration-line-through">
                                  ₹{originalPrice.toLocaleString("en-IN")}
                                </div>
                              )}
                            </div>
                            <span className="fw-bold text-success fs-5">
                              ₹
                              {totalAmount.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                              })}
                            </span>
                          </div>

                          {/* Transaction fields */}
                          <div className="d-flex flex-column fs-5 mt-2 text-dark flex-grow-1">
                            <div className="d-flex justify-content-between">
                              <span className="text-secondary">Payment ID</span>
                              <span
                                className="text-truncate ms-3"
                                style={{
                                  maxWidth: 160,
                                  fontFamily: "monospace",
                                }}
                                title={payment.paymentId}
                              >
                                {payment.paymentId || "—"}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between">
                              <span className="text-secondary">Order ID</span>
                              <span
                                className="text-truncate ms-3"
                                style={{
                                  maxWidth: 160,
                                  fontFamily: "monospace",
                                }}
                                title={payment.orderId}
                              >
                                {payment.orderId || "—"}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between">
                              <span className="text-secondary">Course ID</span>
                              <span
                                style={{
                                  fontFamily: "monospace",
                                }}
                              >
                                {payment.courseId || "—"}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between">
                              <span className="text-secondary">Currency</span>
                              <span className="fw-semibold">
                                {payment.currency || "INR"}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between">
                              <span className="text-secondary">
                                Date / Time
                              </span>
                              <span>{formatDate(payment.createdAt)}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                              <span className="text-secondary">Status</span>
                              <span
                                className={`badge text-capitalize rounded-pill ${
                                  payment.status === "success"
                                    ? "bg-success-subtle text-success"
                                    : "bg-danger-subtle text-danger"
                                }`}
                              >
                                {payment.status === "success" ? "✓ " : ""}
                                {payment.status || "—"}
                              </span>
                            </div>
                          </div>

                          {/* Download button */}
                          <div className="mt-4">
                            <button
                              onClick={() => generateInvoice(payment)}
                              className="btn bg-danger fw-medium text-white w-100 rounded-pill border-0"
                            >
                              Download Invoice{" "}
                              <i className="bi bi-download ms-1" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Payments;
